import { render, staticRenderFns } from "./PriceTable.vue?vue&type=template&id=aaa5ea80&scoped=true"
import script from "./PriceTable.vue?vue&type=script&lang=js"
export * from "./PriceTable.vue?vue&type=script&lang=js"
import style0 from "./PriceTable.vue?vue&type=style&index=0&id=aaa5ea80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa5ea80",
  null
  
)

export default component.exports